import Button from 'common/components/buttons/button';
import { ButtonTheme } from 'common/components/buttons/button-theme';
import { ModalSimple } from 'features/modal/modal-simple';
import {
  Segment,
  SegmentFilter,
  SegmentFilterBeingEdited
} from '../segment-controls.types';
import { useState } from 'react';
import SegmentDropdown from './segments/segment-dropdown';
import SegmentFilters from './filters/segment-filters';
import SegmentFilterDropdown from './filters/segment-filter-dropdown';
import AddSegmentButton from './segments/add-segment-button';

interface SegmentControlProps {
  componentId: string;
  segment: Segment;
  isFirstSegment: boolean;
  filterBeingEdited?: SegmentFilterBeingEdited;
  filters: SegmentFilter[];
  isLastSegment: boolean;
  hideAddBtn: boolean;
  onDeleteSegment: (segment: Segment) => void;
  onFilterAdded: (segment: Segment) => void;
  onFilterBeingEditedChanged: (filter: SegmentFilter | undefined) => void;
  onFilterSaved: () => void;
}

const SegmentControl = ({
  componentId,
  segment,
  isFirstSegment,
  filterBeingEdited,
  filters,
  isLastSegment,
  hideAddBtn,
  onDeleteSegment,
  onFilterAdded,
  onFilterBeingEditedChanged,
  onFilterSaved
}: SegmentControlProps) => {
  const [segmentToDelete, setSegmentToDelete] = useState<Segment | undefined>();

  const onSetDeleteSegment = (segment?: Segment) => {
    setSegmentToDelete(segment);
  };

  const handleOnDeleteSegment = () => {
    onDeleteSegment(segmentToDelete!);
    onSetDeleteSegment();
  };

  return (
    <div className="flex flex-col w-fit">
      <div className="flex items-stretch">
        <div className="flex items-stretch relative">
          <SegmentDropdown
            componentId={componentId}
            key={`segment-dropdown-${segment.id}`}
            segment={segment}
          />
        </div>

        <div className={`flex ${isFirstSegment ? 'ml-2' : 'mx-1 md:mx-2'}`}>
          {!isFirstSegment ? (
            <Button
              identifier={`delete-segment-${segment.id}`}
              theme={ButtonTheme.CANCEL}
              isDisabled={isFirstSegment}
              onClick={() => onSetDeleteSegment(segment)}
            >
              <i className="flex items-center ra-icons-generic-bin"></i>
            </Button>
          ) : (
            <></>
          )}
          <ModalSimple
            title="Delete Segment"
            theme={ButtonTheme.ERROR}
            isOpen={segmentToDelete !== undefined}
            onCancelModal={() => onSetDeleteSegment()}
            onConfirmModal={handleOnDeleteSegment}
            confirmButtonText="Delete Segment"
            description={`Are you sure you want to delete segment ${segment.segmentCategory}`}
          ></ModalSimple>
        </div>
        <div className="whitespace-nowrap flex items-center text-sm">
          <SegmentFilters
            componentId={componentId}
            segment={segment}
            segmentFilters={filters}
          />
        </div>
        <div className="flex">
          <SegmentFilterDropdown
            filter={filterBeingEdited}
            onFilterAdded={() => onFilterAdded(segment)}
            onFilterBeingEditedChanged={onFilterBeingEditedChanged}
            onFilterSaved={onFilterSaved}
          />
        </div>
      </div>
      {isLastSegment && !hideAddBtn ? (
        <div className="mt-2 md:ml-18 flex flex-row items-center">
          <AddSegmentButton componentId={componentId} />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SegmentControl;
